import React, { useState } from "react";
import Button from "@ui-components/Button";
import { PageHeading } from "@ui-components/Container";
import { KColorInput } from "@feature/kcolor/kcolor-input";
import { PriceListSearchProps } from "../types";
import { useComputeKColor } from "@feature/kcolor/hooks/useComputeKColor";
import CloseIcon from "@components/CloseIcon";

import { PriceListSearchResult } from "../";
import {FormattedMessage} from "react-intl";

export const PriceListSearch = ({
  intl,
  publicMode = false,
  startSearch,
  setStartSearch,
  priceListData,
  setPriceListData,
  canSearch,
  setCanSearch,
  push,
}: PriceListSearchProps) => {

  // hooks
  const { recompute: recomputePriceList, loading: priceListLoading } = useComputeKColor(true, publicMode);

  // state
  const [priceListResult, setPriceListResult] = useState({});

  return (
    <main className="flex-grow flex flex-col justify-center w-full mx-auto gap-5">
      <PageHeading
        title={intl.formatMessage({
          id: "price_list_title",
          defaultMessage: "Listino Kerakoll Colors",
        })}
        contentActions={
          startSearch && !Object.keys(priceListResult).length
            ? <CloseIcon onClick={() => {setStartSearch(false); }} children={undefined} />
            : undefined
        }
      />
      {!!Object.keys(priceListResult).length ? (
        <PriceListSearchResult
          priceList={{ ...priceListResult, ...priceListData }}
          onUpdatePriceList={() => {
            setPriceListResult({});
          }}
          onExit={() => {
            setPriceListResult({});
            setPriceListData({});
            if (setStartSearch)
              setStartSearch(false);
            if (setCanSearch)
              setCanSearch(false);
          }}
        />
      ) : (
        startSearch || publicMode ? (
          <>
            <KColorInput
              value={priceListData}
              onChange={(data) => {
                if (
                  data?.color &&
                  data?.kColorProduct &&
                  data?.productPackage
                ) {
                  setPriceListData(data);
                  setCanSearch(true);
                } else {
                  setCanSearch(false);
                }
              }}
            />
            <hr className="w-full border-gray-300" />
            <Button
              className="w-full sm:auto md:w-auto"
              disabled={!canSearch}
              submitting={priceListLoading}
              onClick={async () => {
                try {
                  const res = await recomputePriceList(priceListData);
                  if (res) {
                    setPriceListResult(res);
                    if (res.edit_id)
                      setPriceListData({
                        ...priceListData,
                        edit_id: res.edit_id,
                      });
                    push({
                      type: "success",
                      title: intl.formatMessage({
                        id: "price_list_retrieved",
                        defaultMessage: "Listino recuperato",
                      }),
                    });
                  }
                } catch (e: any) {
                  if (e.response?.status === 404) {
                    push({
                      type: "warning",
                      title: intl.formatMessage({
                        id: "kcolor_price_list_not_found",
                        defaultMessage: "Listino non trovato per la combinazione selezionata",
                      }),
                    });
                  }
                  else {
                    console.error(e);
                    push({
                      type: "error",
                      title: intl.formatMessage({ id: "server_error" }),
                    });
                  }
                }
              }}
            >
              {intl.formatMessage({
                id: "price_list_search",
                defaultMessage: "Vai al prezzo",
              })}
            </Button>
          </>
        ) : (
          <Button
            className="w-full md:w-auto"
            onClick={() => setStartSearch(true)}
          >
            <FormattedMessage id="price_list_start_search" defaultMessage="Nuova ricerca" />
          </Button>
        )
      )}
    </main>
  );
};
